module.exports = __webpack_public_path__ + "static/media/payment.fbf47c0b.svg";